module.exports = __webpack_public_path__ + "static/rni-b09112bc0c2fd8bcb9333bfc6fc6bc41.png";